<template>
  <v-container fluid align-start ma-0 pa-2 class="chgPwd-main container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle"
                         :useBtnList="useBtnList"
                         :btnKey="useBtnListKey"
                         @btnSave="btnSave"
        >
          <template v-slot:body>
            <v-layout column >
              <v-row dense class="form-layout">
                <v-col cols="1" class="pr-2 pt-1 formHeader">
                  <span>Curent Password</span>
                </v-col>
                <v-col cols="2" class="pl-2 pt-1 form-border-right">
                  <v-text-field
                      v-model="currentPasswod"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show1 ? 'text' : 'password'"
                      dense
                      @click:append="show1 = !show1"
                  />
                </v-col>
              </v-row>
              <v-row dense class="form-layout mt-0">
                <v-col cols="1" class="pr-2 pt-1 formHeader">
                  <span>New Password</span>
                </v-col>
                <v-col cols="2" class="pl-2 pt-1 form-border-right">
                  <v-text-field
                      v-model="newPassword"
                      :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show2 ? 'text' : 'password'"
                      dense
                      @click:append="show2 = !show2"
                  />
                </v-col>
              </v-row>
              <v-row dense class="form-layout mt-0">
                <v-col cols="1" class="pr-2 pt-1 form-border-bottom-left formHeader ">
                  <span>Confirm Password</span>
                </v-col>
                <v-col cols="2" class="pl-2 pt-1  form-border-bottom form-border-right">
                  <v-text-field
                      v-model="confirmPassword"
                      :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show3 ? 'text' : 'password'"
                      dense
                      @click:append="show3 = !show3"
                  />
                </v-col>
              </v-row>
              <v-row dense class="form-layout mt-0 form-warning">
                Password should be Character and Number.<br>
                Password must be over 6 character and less than 12 character.
              </v-row>

            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ICardVertical from '@/components/common/iCardVertical'
import iCardTop from '@/components/common/iCardTop'
import baseview from '@/components/base/baseview'
import { getNoticeList } from '@/api/view/hycot/Z/admZ000'
import { updatePassword } from '@/api/view/hycot/I/chgPwd.js'

import notify from "devextreme/ui/notify";


export default {
  name: 'chgPwd',
  mixins: [baseview],
  components: {
    ICardVertical,
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      useBtnList: ['btnSave' ],
      useBtnListKey : 0,
      currentPasswod : '',
      newPassword : '',
      confirmPassword : '',
      show1 : false,
      show2 : false,
      show3 : false,
      userGrd: this.$store.state.user.userGrd,

      //  edtNoticeData: '',
      //  edtNoticeConfig: {}
    }
  },
  computed: {

  },
  methods: {
    init() {
    },


    async btnSave() {

      if(this.currentPasswod === null || this.currentPasswod === ''){
        this.vToastify(this.$t('Input current password.'), 'warn');
        return;
      }

      if(this.newPassword === null || this.newPassword === ''){
        this.vToastify(this.$t('Input new password.'), 'warn');
        return;
      }

      if(this.confirmPassword === null || this.confirmPassword === ''){
        this.vToastify(this.$t('Input confirm password.'), 'warn');
        return;
      }

      if(this.newPassword != this.confirmPassword){
        this.vToastify(this.$t('New password is different with confirm password.'), 'warn');
        return;
      }

      if (this.userGrd != "A" && this.newPassword == this.currentPasswod) {
        this.vToastify(this.$t('New password must be different with old password.'), 'warn');
        return;
      }

      if (this.newPassword < 6) {
        this.vToastify(this.$t('Password must be over 6 character.'), 'warn');
        return;
      }


      let firstChar = this.newPassword.substring(0, 1);
      if (!((firstChar >= "A" && firstChar <= "Z") || (firstChar >= "a" && firstChar <= "z"))){
        this.vToastify(this.$t('Password must be start with alphabet.'), 'warn');
        return;
      }

      let includeNumber = false;
      let includeSpace  = false;
      for ( var i = 0; i < this.newPassword.length; i++){
        let myChar = this.newPassword.substring(i, i + 1);
        if (myChar >= "0" && myChar <= "9") { includeNumber = true; }
        if (myChar == " ") { includeSpace = true; }
      }

      if (!includeNumber) {
        this.vToastify(this.$t('Password must be contain number.'), 'warn');
        return;
      }
      if (includeSpace) {
        this.vToastify(this.$t('Password cannot contain space.'), 'warn');
        return;
      }




      let params = {
        sysId : this.$store.state.system.sysId, 
        userId: this.$store.state.user.userId,
        currentPassword: this.currentPasswod,
        newPassword: this.newPassword,
      }

      const vm = this
      vm.vToastifyPrompt(
          vm.$t('Do you want to change new password?'),
          'info',
          current => {
            console.log("save passwod button click", params);

            this.openLoading('update password...')
            updatePassword(params)
                .then(res => {
                  this.vToastify(this.$t("Your password is successfully updated."), 'warn')
                  //notify(this.$t('changed'), 'success', 1500)
                  //this.doSearchMain()
                })
                .catch(error => {
                  this.vToastify(this.$t('An error has occured while changing password.<br>nCheck your old password and try again.'), 'warn')
                  //notify(error, 'error', 1500)
                  this.endLoading()
                })
                .finally(() => {
                  this.endLoading()
                })
          },
          null,
          true
      )
    },
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.form-layout .col {
  border-width: 1px 0 0 1px;
  border-style: solid;
  border-color: gray;


}
.form-border-right {
  border-width: 1px 1px 0 1px !important;
  border-style: solid !important;
  border-color: gray !important;
}

.form-border-bottom-left {
  border-width: 1px 0px 1px 1px !important;
  border-style: solid !important;
  border-color: gray !important;
}

.form-border-bottom {
  border-width: 1px 1px 1px 1px !important;
  border-style: solid !important;
  border-color: gray !important;
}

.formHeader {
  background-color: rgb(223, 227, 213);
  font-weight: bold;
  // border: 1px solid gray;
  color: black;
  font-size: 9pt;
}

.form-warning{
  font-width: 10px;
  font-family: bold;
  color : blue;
}

</style>